export default "__VITE_ASSET__CUPcaBpb__"